module.exports = __webpack_public_path__ + "static/media/sreekanth.8d94ad62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sreekanth.jpg
// module id = 190
// module chunks = 0